module.exports = __webpack_public_path__ + "img/answer-img4.0d5272f2.png";